import { ContentDelete } from '@fs/zion-icon'
import { useOverlay, DangerButton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import UnshareGroupReservationsDialog from './UnshareGroupReservationsDialog'

export default function UnshareGroupReservationsButton({ checkedRanIds, refetchReservations }) {
  const overlay = useOverlay()
  const { t } = useTranslation()

  return (
    <>
      <DangerButton Icon={ContentDelete} onClick={overlay.handleClick}>
        {t('group.reservations.buttons.unshare', 'Unshare')}
      </DangerButton>
      <UnshareGroupReservationsDialog
        checkedRanIds={checkedRanIds}
        refetchReservations={refetchReservations}
        {...overlay}
      />
    </>
  )
}
